import * as React from 'react';
import SVGIcon from '../SVGIcon';

const NoInvitesIcon: React.FC = () => (
  <SVGIcon width="304" height="294" viewBox="0 0 608 588" fill="none">
    <>
      <path
        d="M411.156 553.654H197.819C189.671 553.654 183.067 546.802 183.067 538.352V529.25C183.067 520.8 189.671 513.949 197.819 513.949H411.156C401.4 525.012 401.23 541.919 410.766 553.192L411.156 553.654Z"
        fill="#B75742"
      />
      <path
        d="M407.865 518.499H289.534C281.386 518.499 274.782 525.351 274.782 533.801C274.782 542.255 281.386 549.103 289.534 549.103H407.875C402.344 539.716 402.354 527.862 407.865 518.499Z"
        fill="#FAE0B2"
      />
      <path
        d="M336.209 486.373C336.518 485.792 336.046 485.117 335.33 485.117H222.446C213.596 485.117 206.425 491.572 206.425 499.536C206.425 507.498 213.596 513.956 222.446 513.956H335.361C336.08 513.956 336.555 513.277 336.24 512.693C331.77 504.359 331.78 494.67 336.209 486.373Z"
        fill="#86B1F2"
      />
      <path
        d="M335.497 487.801H279.55C269.166 487.801 260.75 493.211 260.75 499.883C260.75 506.558 269.166 511.967 279.55 511.967H335.863C332.015 504.277 331.91 495.522 335.497 487.801Z"
        fill="#F7CC7F"
      />
      <path
        d="M321.047 493.53H313.761C312.196 493.53 310.924 494.056 310.924 494.704V494.809H321.047V493.53Z"
        fill="#B75742"
      />
      <path
        d="M327.264 496.475C327.264 494.846 325.36 493.53 323.012 493.53H313.662C315.444 493.53 316.886 494.531 316.886 495.763L316.842 527.353L322.007 523.291L327.274 527.353L327.264 496.475Z"
        fill="#F47458"
      />
      <path
        d="M315.454 484.079H249.772C243.948 484.079 239.228 478.472 239.228 471.56C239.228 464.647 243.948 459.044 249.772 459.044H315.454C310.435 465.984 310.238 476.161 314.986 483.366L315.454 484.079Z"
        fill="#FAE0B2"
      />
      <path
        d="M239.235 471.559C239.235 464.647 244.067 459.044 250.03 459.044H316.707C317.019 459.044 317.27 458.749 317.267 458.389C317.263 458.033 317.012 457.748 316.707 457.748H210.929C204.352 457.748 199.017 463.931 199.017 471.559C199.017 479.192 204.352 485.375 210.929 485.375H316.707C317.012 485.375 317.263 485.086 317.267 484.733C317.27 484.37 317.015 484.078 316.707 484.078H250.03C244.067 484.078 239.235 478.472 239.235 471.559Z"
        fill="#466EB6"
      />
      <path
        d="M303.984 465.193H296.698C295.133 465.193 293.861 465.712 293.861 466.347V466.452H303.984V465.193Z"
        fill="#184655"
      />
      <path
        d="M310.201 468.085C310.201 466.49 308.297 465.193 305.948 465.193H296.599C298.381 465.193 299.823 466.177 299.823 467.385L299.779 498.365L304.944 494.381L310.211 498.365L310.201 468.085Z"
        fill="#3C8F7C"
      />
      <path
        d="M420.106 273.84L429.801 271.288L423.231 358.944L411.598 359.331L417.465 277.023C417.574 275.506 418.636 274.226 420.106 273.84Z"
        fill="#184655"
      />
      <path
        d="M424.1 361.441C423.883 361.462 423.662 361.458 423.435 361.431C421.511 361.204 420.085 359.29 420.251 357.155L426.706 274.732C426.872 272.597 428.569 271.05 430.497 271.277C432.421 271.505 433.846 273.419 433.68 275.557L427.225 357.98C427.076 359.863 425.736 361.292 424.1 361.441Z"
        fill="#F7CC7F"
      />
      <path
        d="M334.859 365.833C334.862 365.894 334.865 365.951 334.872 366.012C335.174 369.365 337.774 371.877 340.672 371.615L422.562 364.285C425.464 364.027 427.568 361.099 427.266 357.746C427.252 357.603 427.235 357.464 427.211 357.325L334.859 365.833Z"
        fill="#F7CC7F"
      />
      <path
        d="M391.881 454.364C386.519 457.337 370.128 452.125 370.128 451.653C369.894 456.132 351.776 499.977 351.776 499.977L351.789 513.467C351.789 513.467 389.122 515.245 388.586 511.947C388.05 508.648 386.041 510.793 378.595 504.562C377.933 504.009 367.478 501.583 370.305 495.393C376.006 482.928 388.107 462.146 391.881 454.364Z"
        fill="#F7A491"
      />
      <path
        d="M350.561 513.949L391.429 513.959C392.902 513.81 393.248 512.608 392.726 511.879C391.653 510.379 383.821 506.836 378.558 504.488C369.388 505.556 353.269 502.031 351.792 499.94C347.91 505.139 349.739 513.779 350.561 513.949Z"
        fill="#3C8F7C"
      />
      <path
        d="M341.598 422.885C341.045 421.226 376.783 406.06 378.381 407.794C381.211 410.859 359.044 468.393 359.044 468.393L384.513 476.175C384.513 476.175 410.987 409.705 409.88 397.546C408.777 385.39 395.515 371.575 366.778 380.415C338.042 389.258 341.598 422.885 341.598 422.885Z"
        fill="#355389"
      />
      <path
        d="M415.592 461.925C409.558 460.829 401.739 460.517 395.478 460.408C396.218 465.981 399.798 494.558 399.143 496.316C396.493 503.429 390.608 506.758 390.608 506.758C390.608 506.758 418.358 531.796 420.031 528.904C421.707 526.013 418.796 526.4 416.983 516.861C416.824 516.012 412.809 502.696 412.561 495.515C412.086 481.819 415.385 469.534 415.592 461.925Z"
        fill="#F7A491"
      />
      <path
        d="M406.687 368.432C402.815 366.369 392.767 366.294 381.717 367.01C360.171 368.408 338.904 372.647 318.41 379.437L304.696 383.978L304.741 369.918C304.741 369.918 261.113 362.619 259.592 373.431C257.309 389.713 260.146 422.773 274.68 430.151C319.832 453.071 383.105 393.64 383.336 401.414C383.641 411.856 392.444 450.716 394.698 467.728C400.955 467.837 411.71 467.833 416.376 466.761C417.282 433.433 417.706 374.313 406.687 368.432Z"
        fill="#466EB6"
      />
      <path
        d="M389.76 507.345L420.957 532.26C422.193 533.082 423.218 532.372 423.279 531.477C423.401 529.634 419.586 521.93 417.004 516.779C409.233 511.794 398.981 498.8 399.167 496.248C395.875 499.024 389.234 506.69 389.76 507.345Z"
        fill="#3C8F7C"
      />
      <path
        d="M319.153 232.523C318.108 222.943 317.002 213.329 309.064 206.307C302.637 200.626 294.468 199.663 286.388 202.703C263.499 211.316 275.291 231.644 246.107 252.141C237.036 258.511 227.041 262.868 220.214 271.444C210.654 283.45 214.265 297.886 222.973 307.528C264.653 353.653 311.182 291.361 314.525 276.405C317.009 265.281 319.829 238.689 319.153 232.523Z"
        fill="#13375B"
      />
      <path
        d="M310.689 286.386C307.286 280.111 303.78 275.129 303.78 275.129C300.247 268.851 291.125 265.678 291.125 265.678C291.125 265.678 288.074 265.739 284.569 265.912C284.352 266.492 284.131 266.906 283.907 267.073C282.59 268.06 275.043 266.788 270.17 270.096C253.83 284.102 258.35 351.99 259.633 373.431L309.396 373.903C309.396 373.903 303.122 327.767 313.231 315.913C320.273 307.66 315.742 295.698 310.689 286.386Z"
        fill="#50BFA5"
      />
      <path
        d="M288.261 242.71C288.261 242.71 285.526 262.244 283.616 266.991C281.705 271.739 294.119 281.889 304.449 284.974C314.779 288.055 301.293 274.488 301.72 269.411C302.148 264.338 304.028 240.311 304.028 240.311L288.261 242.71Z"
        fill="#F7A491"
      />
      <path
        d="M303.505 247.2C303.807 243.226 304.028 240.311 304.028 240.311L288.261 242.71C288.261 242.71 287.864 245.004 287.423 248.249C293.817 251.958 299.562 250.787 303.505 247.2Z"
        fill="#F47458"
      />
      <path
        d="M293.206 207.03C293.206 207.03 286.992 208.432 283.154 214.286C279.319 220.139 276.686 237.379 289.324 245.425C301.958 253.471 311.786 242.089 311.949 230.989C312.112 219.885 309.733 205.072 293.206 207.03Z"
        fill="#F7A491"
      />
      <path
        d="M314.843 227.514C313.764 230.191 311.626 231.854 310.065 231.226C308.504 230.599 308.114 227.918 309.193 225.24C310.269 222.559 312.407 220.896 313.968 221.528C315.529 222.155 315.919 224.836 314.843 227.514Z"
        fill="#F7A491"
      />
      <path
        d="M295.069 206.667C295.069 206.667 287.148 224.436 280.188 226.021C273.228 227.609 273.33 236.551 273.33 236.551C273.33 236.551 273.482 215.901 280.008 211.167C286.531 206.43 295.069 206.667 295.069 206.667Z"
        fill="#13375B"
      />
      <path
        d="M282.954 229.716C283.87 232.601 283.032 235.441 281.08 236.062C279.129 236.68 276.805 234.844 275.888 231.959C274.972 229.071 275.81 226.231 277.762 225.61C279.713 224.992 282.037 226.828 282.954 229.716Z"
        fill="#F7A491"
      />
      <path
        d="M371.958 358C368.971 356.921 364.529 356.785 364.604 356.392C364.902 354.797 378.093 359.914 376.312 357.586C375.317 356.29 365.449 351.698 363.046 352.455C360.718 353.192 345.433 357.481 345.433 357.481L303.655 347.691C303.655 347.691 293.111 323.728 292.079 303.14C283.365 304.321 277.429 306.472 269.855 310.677C273.506 330.366 282.387 362.28 292.205 368.269C296.332 370.787 345.64 365.252 345.64 365.252C345.64 365.252 356.507 364.485 358.281 363.803C359.629 363.284 363.097 361.333 364.98 360.797C369.27 359.585 376.905 362.632 376.929 361.791C376.946 361.18 375.008 359.103 371.958 358Z"
        fill="#F7A491"
      />
      <path
        d="M292.337 281.142C291.933 274.81 289.534 268.691 282.794 266.723C278.617 265.501 273.93 266.669 270.591 269.397C266.621 272.642 265.511 277.844 265.531 282.768C265.572 293.953 266.336 305.546 268.379 316.558C275.953 312.353 284.797 309.825 293.515 308.644C293.511 308.58 292.867 289.514 292.337 281.142Z"
        fill="#96D9C9"
      />
      <path
        d="M354.782 430.901H186.719C181.499 430.901 177.271 435.133 177.271 440.352V448.3C177.271 453.519 181.499 457.751 186.719 457.751H354.782L354.694 457.659C347.507 450.177 347.544 438.34 354.782 430.901Z"
        fill="#F47458"
      />
      <path
        d="M351.81 434.875H261.965C256.745 434.875 252.513 439.107 252.513 444.326C252.513 449.546 256.745 453.777 261.965 453.777H351.806C348.504 447.923 348.508 440.722 351.81 434.875Z"
        fill="#FAE0B2"
      />
      <path
        d="M153.785 253.996L150.567 257.792L143.888 253.289L138.501 258.262L132.951 255.708L131.658 258.521L139.081 261.933L144.187 257.221L151.136 261.905L155.977 256.19L153.785 253.996Z"
        fill="#50BFA5"
      />
      <path
        d="M554.128 313.29L550.91 317.086L544.231 312.584L538.845 317.556L533.294 315.003L532.004 317.813L539.423 321.225L544.531 316.516L551.479 321.2L556.321 315.485L554.128 313.29Z"
        fill="#50BFA5"
      />
      <path
        d="M177.227 177.234C167.454 186.029 173.399 202.441 186.588 203.033C188.958 203.138 191.196 204.146 192.92 205.779L198.843 211.386C200.478 212.93 203.023 212.963 204.695 211.46L208.395 208.125C210.067 206.622 210.303 204.085 208.934 202.301C203.947 195.784 201.638 193.741 201.908 189.239C202.698 176.064 186.996 168.433 177.227 177.234Z"
        fill="#F7CC7F"
      />
      <path
        d="M189.614 182.882C189.776 183.882 190.546 184.8 191.364 185.9C191.932 184.818 192.56 183.516 192.301 182.369C192.118 181.563 191.261 180.81 190.486 181.065C190.4 181.096 189.503 182.179 189.614 182.882ZM182.202 193.598C183.142 193.838 184.244 193.507 185.563 192.572C184.686 191.72 183.761 191.043 182.662 190.845C180.181 190.395 180.626 193.19 182.202 193.598ZM197.018 205.658C192.527 200.217 187.538 194.628 186.066 193.08C180.028 197.438 178.179 189.316 182.787 190.147C184.099 190.383 185.153 191.171 186.139 192.143C188.095 190.623 189.75 188.728 190.988 186.584C189.956 185.194 189.106 184.183 188.915 182.991C188.628 181.192 190.162 179.668 191.767 180.574C192.368 180.915 192.838 181.541 192.991 182.213C193.316 183.645 192.546 185.223 191.828 186.53C195.164 191.006 198.647 195.44 202.203 199.723L201.662 200.175C198.163 195.96 194.732 191.601 191.446 187.198C190.192 189.291 188.56 191.148 186.634 192.652C188.511 194.637 193.346 200.099 197.564 205.208L197.018 205.658Z"
        fill="#FAE0B2"
      />
      <path
        d="M192.765 205.644C192.814 205.689 192.869 205.731 192.92 205.779L198.843 211.386C200.478 212.93 203.023 212.963 204.695 211.46L208.395 208.125C210.067 206.622 210.303 204.085 208.935 202.302C206.717 199.402 205.028 197.389 203.863 195.653L192.765 205.644Z"
        fill="#96D9C9"
      />
      <path
        d="M165.938 177.444L158.851 173.574C158.168 173.201 157.915 172.34 158.29 171.656C158.664 170.969 159.522 170.717 160.21 171.091L167.295 174.957C167.979 175.333 168.233 176.194 167.857 176.879C167.481 177.567 166.621 177.816 165.938 177.444Z"
        fill="#FAE0B2"
      />
      <path
        d="M168.044 196.438L160.525 200.378C159.834 200.741 158.978 200.475 158.617 199.779C158.255 199.088 158.521 198.233 159.212 197.871L166.731 193.93C167.422 193.568 168.277 193.833 168.641 194.527C169.003 195.218 168.738 196.074 168.044 196.438Z"
        fill="#FAE0B2"
      />
      <path
        d="M174.974 222.783C174.211 222.611 173.732 221.858 173.904 221.095C174.548 218.244 175.463 215.44 176.634 212.763C176.945 212.048 177.778 211.719 178.496 212.033C179.211 212.344 179.54 213.178 179.226 213.895C178.128 216.409 177.267 219.04 176.665 221.716C176.494 222.474 175.739 222.958 174.974 222.783Z"
        fill="#FAE0B2"
      />
      <path
        d="M183.319 165.847C182.577 166.085 181.781 165.673 181.543 164.93C180.414 161.397 178.913 157.966 177.083 154.741C176.699 154.06 176.935 153.195 177.616 152.811C178.295 152.424 179.157 152.662 179.544 153.341C181.473 156.74 183.051 160.348 184.239 164.069C184.478 164.818 184.059 165.611 183.319 165.847Z"
        fill="#FAE0B2"
      />
      <path
        d="M196.516 170.299C195.923 169.789 195.852 168.899 196.361 168.303L202.333 161.331C202.841 160.735 203.733 160.667 204.329 161.176C204.921 161.684 204.99 162.578 204.482 163.17L198.513 170.144C198.005 170.736 197.112 170.808 196.516 170.299Z"
        fill="#FAE0B2"
      />
      <path
        d="M221.294 182.198C221.189 182.266 221.071 182.321 220.944 182.362C217.915 183.284 214.783 183.881 211.628 184.141C210.851 184.204 210.167 183.622 210.104 182.845C210.041 182.067 210.62 181.386 211.398 181.322C214.35 181.079 217.284 180.52 220.119 179.654C220.864 179.426 221.654 179.847 221.883 180.595C222.072 181.216 221.814 181.865 221.294 182.198Z"
        fill="#FAE0B2"
      />
      <path
        d="M363.439 165.376L354.044 158.939L343.42 163.028C342.21 163.493 340.99 162.368 341.358 161.125L344.575 150.203L337.401 141.362C336.585 140.354 337.278 138.849 338.576 138.812L349.956 138.499L356.149 128.943C356.856 127.857 358.501 128.047 358.936 129.272L362.752 139.999L373.753 142.937C375.006 143.27 375.331 144.896 374.303 145.688L365.279 152.632L365.887 164.001C365.955 165.296 364.507 166.106 363.439 165.376Z"
        fill="#F7CC7F"
      />
      <path
        d="M403.457 96.987L405.884 104.15L394.785 109.329L397.043 120.241L389.373 125.475L392.022 129.356L402.278 122.359L400.144 112.017L411.686 106.631L408.032 95.8485L403.457 96.987Z"
        fill="#F48C7F"
      />
      <path
        d="M152.715 366.227L91.6769 391.025C90.4508 391.521 89.0541 390.933 88.5537 389.706L71.8731 348.645C71.3774 347.419 71.9655 346.022 73.1926 345.522L134.228 320.726C135.455 320.226 136.854 320.817 137.349 322.043L154.032 363.106C154.53 364.33 153.939 365.729 152.715 366.227Z"
        fill="#F7CC7F"
      />
      <path
        d="M99.8796 340.928L81.2986 348.477C80.0725 348.973 78.6757 348.384 78.1754 347.157L75.6389 340.911C75.1414 339.682 75.7294 338.285 76.9584 337.788L95.5365 330.241C96.7636 329.741 98.1593 330.333 98.6579 331.558L101.196 337.807C101.695 339.031 101.104 340.43 99.8796 340.928Z"
        fill="#F7CC7F"
      />
      <path
        d="M154.299 363.233C154.659 364.417 154.055 365.683 152.907 366.149L91.472 391.108C90.3293 391.57 89.0191 391.092 88.4476 389.999L70.2427 355.277C69.9315 354.678 69.8839 353.975 70.1138 353.34C70.3483 352.706 70.8375 352.199 71.4634 351.943L139.713 324.216C140.338 323.964 141.039 323.982 141.646 324.275C142.255 324.565 142.712 325.095 142.907 325.74L154.299 363.233Z"
        fill="#FAE0B2"
      />
      <path
        d="M327.393 82.7716L319.691 91.3076L310.426 81.28L313.132 78.7795L319.657 85.8395L324.657 80.3011L327.393 82.7716Z"
        fill="#50BFA5"
      />
      <path
        d="M150.988 208.353L105.788 266.815C104.331 268.7 101.623 269.045 99.7379 267.589L69.4903 244.201C67.6056 242.745 67.2581 240.033 68.7163 238.151L113.915 179.687C115.373 177.805 118.08 177.456 119.965 178.913L150.214 202.303C152.099 203.76 152.448 206.467 150.988 208.353Z"
        fill="#86B1F2"
      />
      <path
        d="M107.154 225.454C113.179 230.113 114.291 238.776 109.629 244.804C104.97 250.829 96.3088 251.938 90.2786 247.278C84.253 242.619 83.1466 233.957 87.8038 227.928C92.4629 221.903 101.128 220.795 107.154 225.454Z"
        fill="white"
      />
      <path
        d="M96.8379 229.772C98.6177 231.147 98.9408 233.701 97.5692 235.479C96.193 237.256 93.6407 237.582 91.8627 236.21C90.0857 234.834 89.758 232.279 91.1342 230.502C92.5076 228.727 95.0627 228.399 96.8379 229.772Z"
        fill="#86B1F2"
      />
      <path
        d="M108.537 235.744L100.589 246.027L99.4328 245.135C97.33 243.508 96.9411 240.48 98.5708 238.376L100.624 235.717C102.254 233.613 105.279 233.226 107.386 234.854L108.537 235.744Z"
        fill="#86B1F2"
      />
      <path
        d="M104.533 218.189C103.91 218.588 103.098 218.553 102.509 218.1C101.742 217.507 101.601 216.4 102.194 215.634L121.954 190.077C122.077 189.918 122.225 189.778 122.394 189.67C123.02 189.269 123.834 189.307 124.42 189.762C125.187 190.355 125.331 191.46 124.735 192.229L104.978 217.783C104.852 217.944 104.705 218.079 104.533 218.189Z"
        fill="white"
      />
      <path
        d="M115.544 220.144C114.919 220.545 114.104 220.507 113.516 220.054C112.749 219.461 112.608 218.354 113.203 217.586L128.634 197.626C128.757 197.466 128.907 197.33 129.076 197.222C129.702 196.821 130.514 196.856 131.1 197.311C131.473 197.596 131.711 198.012 131.771 198.477C131.829 198.944 131.705 199.406 131.415 199.777L115.985 219.737C115.861 219.897 115.713 220.036 115.544 220.144Z"
        fill="white"
      />
      <path
        d="M504.85 305.12L476.878 285.086C475.47 284.078 475.146 282.121 476.155 280.713L504.888 240.594C505.896 239.186 507.853 238.862 509.261 239.87L537.234 259.904C538.642 260.912 538.965 262.869 537.957 264.277L509.224 304.396C508.216 305.804 506.258 306.128 504.85 305.12Z"
        fill="#FAE0B2"
      />
      <path
        d="M531.284 266.224L506.147 248.224C505.743 247.934 505.65 247.373 505.94 246.97C506.229 246.566 506.79 246.473 507.196 246.761L532.331 264.763C532.735 265.053 532.828 265.614 532.538 266.017C532.249 266.42 531.688 266.514 531.284 266.224Z"
        fill="#466EB6"
      />
      <path
        d="M524.648 265.983L504.013 251.203C503.61 250.914 503.517 250.353 503.806 249.949C504.094 249.543 504.657 249.453 505.06 249.742L525.698 264.52C526.101 264.81 526.195 265.371 525.907 265.777C525.617 266.18 525.056 266.274 524.648 265.983Z"
        fill="#466EB6"
      />
      <path
        d="M527.015 272.185L501.878 254.185C501.474 253.895 501.381 253.334 501.67 252.931C501.958 252.525 502.524 252.432 502.927 252.722L528.062 270.724C528.466 271.014 528.559 271.575 528.269 271.978C527.98 272.381 527.419 272.475 527.015 272.185Z"
        fill="#466EB6"
      />
      <path
        d="M519.146 271.058L499.745 257.164C499.341 256.874 499.248 256.314 499.538 255.91C499.825 255.504 500.388 255.413 500.791 255.703L520.193 269.597C520.596 269.886 520.69 270.447 520.4 270.851C520.111 271.254 519.55 271.347 519.146 271.058Z"
        fill="#466EB6"
      />
      <path
        d="M513.872 239.632L513.367 239.27C513.18 239.136 512.927 239.169 512.803 239.346L510.076 243.154C509.949 243.327 509.999 243.581 510.184 243.713L510.692 244.077C510.876 244.208 511.129 244.175 511.256 244.001L513.983 240.194C514.107 240.017 514.059 239.766 513.872 239.632Z"
        fill="#355389"
      />
      <path
        d="M516.039 241.181L515.534 240.82C515.347 240.686 515.094 240.719 514.967 240.897L512.24 244.705C512.113 244.879 512.164 245.128 512.351 245.263L512.858 245.627C513.043 245.758 513.296 245.725 513.423 245.551L516.15 241.743C516.274 241.567 516.226 241.316 516.039 241.181Z"
        fill="#355389"
      />
      <path
        d="M518.203 242.733L517.698 242.372C517.511 242.238 517.258 242.271 517.133 242.447L514.406 246.255C514.28 246.429 514.328 246.68 514.515 246.814L515.022 247.178C515.207 247.31 515.46 247.276 515.587 247.103L518.315 243.29C518.438 243.118 518.39 242.867 518.203 242.733Z"
        fill="#355389"
      />
      <path
        d="M520.369 244.283L519.863 243.922C519.676 243.788 519.424 243.821 519.299 243.997L516.572 247.805C516.446 247.979 516.494 248.23 516.681 248.364L517.188 248.728C517.373 248.86 517.626 248.827 517.75 248.65L520.477 244.842C520.604 244.668 520.556 244.417 520.369 244.283Z"
        fill="#355389"
      />
      <path
        d="M522.533 245.835L522.027 245.473C521.84 245.339 521.587 245.372 521.463 245.549L518.736 249.357C518.609 249.53 518.66 249.78 518.844 249.916L519.35 250.277C519.537 250.411 519.793 250.376 519.917 250.2L522.644 246.392C522.771 246.218 522.72 245.969 522.533 245.835Z"
        fill="#355389"
      />
      <path
        d="M524.699 247.385L524.194 247.023C524.007 246.889 523.754 246.922 523.629 247.099L520.902 250.906C520.776 251.08 520.824 251.332 521.011 251.466L521.516 251.827C521.703 251.961 521.956 251.928 522.081 251.751L524.808 247.944C524.934 247.77 524.886 247.519 524.699 247.385Z"
        fill="#355389"
      />
      <path
        d="M526.863 248.936L526.357 248.575C526.17 248.441 525.917 248.474 525.793 248.651L523.066 252.458C522.939 252.632 522.991 252.882 523.177 253.016L523.683 253.377C523.87 253.511 524.123 253.478 524.247 253.301L526.974 249.494C527.101 249.32 527.05 249.071 526.863 248.936Z"
        fill="#355389"
      />
      <path
        d="M529.029 250.486L528.523 250.125C528.337 249.991 528.084 250.024 527.959 250.2L525.232 254.008C525.106 254.182 525.154 254.433 525.341 254.567L525.846 254.928C526.033 255.063 526.286 255.03 526.411 254.853L529.138 251.045C529.264 250.872 529.216 250.62 529.029 250.486Z"
        fill="#355389"
      />
      <path
        d="M531.192 252.038L530.687 251.677C530.5 251.543 530.247 251.576 530.123 251.752L527.396 255.56C527.269 255.734 527.32 255.983 527.507 256.117L528.013 256.478C528.199 256.613 528.452 256.58 528.577 256.403L531.304 252.595C531.43 252.422 531.379 252.172 531.192 252.038Z"
        fill="#355389"
      />
      <path
        d="M533.359 253.588L532.853 253.227C532.666 253.092 532.414 253.126 532.289 253.302L529.562 257.11C529.436 257.284 529.484 257.535 529.671 257.669L530.176 258.03C530.363 258.164 530.616 258.131 530.74 257.955L533.467 254.147C533.594 253.973 533.546 253.722 533.359 253.588Z"
        fill="#355389"
      />
      <path
        d="M535.523 255.139L535.015 254.775C534.833 254.642 534.58 254.675 534.453 254.854L531.726 258.661C531.599 258.835 531.65 259.085 531.837 259.219L532.343 259.58C532.53 259.714 532.783 259.681 532.907 259.505L535.634 255.697C535.761 255.523 535.71 255.274 535.523 255.139Z"
        fill="#355389"
      />
      <path
        d="M537.689 256.69L537.181 256.326C536.997 256.194 536.744 256.227 536.617 256.401L533.892 260.212C533.766 260.385 533.814 260.637 534.001 260.771L534.506 261.132C534.693 261.266 534.946 261.233 535.071 261.056L537.798 257.249C537.922 257.072 537.876 256.824 537.689 256.69Z"
        fill="#355389"
      />
      <path
        d="M546.435 248.06L545.099 279.688C545.095 279.759 545.102 279.832 545.121 279.9L546.629 285.693C546.806 286.365 547.746 286.416 547.987 285.761L550.106 280.042C550.134 279.972 550.147 279.899 550.151 279.824L551.491 248.113C551.509 247.706 551.185 247.37 550.779 247.372L547.145 247.375C546.764 247.378 546.452 247.678 546.435 248.06Z"
        fill="#B75742"
      />
      <path
        d="M550.149 279.858L550.146 279.936L548.101 285.455L546.561 285.422L545.129 279.931C546.693 279.824 548.499 279.585 550.149 279.858Z"
        fill="#F7CC7F"
      />
      <path
        d="M239.904 111.399C243.238 111.745 250.705 114.949 258.143 115.788C262.497 116.278 264.323 114.273 268.261 112.374C286.94 103.356 284.514 109.909 286.817 108.925C287.098 110.664 289.055 125.609 289.533 128.575C289.973 131.312 288.978 133.301 286.442 134.475C282.538 136.276 278.684 138.226 274.662 139.724C264.356 143.561 256.421 142.262 246.414 140.925C243.758 140.567 242.171 139.021 241.74 136.387C239.744 124.135 240.021 112.57 239.904 111.399Z"
        fill="#466EB6"
      />
      <path
        d="M297.549 121.535C299.893 125.362 300.666 125.934 298.677 126.403C297.479 126.683 296.245 126.841 295.017 126.955C294.154 127.037 293.844 126.61 294.032 125.74C294.305 124.473 294.614 123.214 294.901 121.97C293.388 120.848 292.93 118.712 293.795 117.012C293.972 116.665 293.991 117.148 292.844 110.044C284.226 114.177 278.169 117.128 267.662 122.174C264.854 123.522 261.887 123.993 258.792 123.598C248.102 122.24 237.413 120.876 226.728 119.506C225.278 119.319 224.414 118.236 224.592 116.865C224.73 115.817 225.465 115.297 226.348 114.876C228.751 113.731 252.281 102.466 254.662 101.307C257.789 99.7827 261.05 99.2361 264.505 99.6777C275.009 101.023 285.518 102.332 296.022 103.658C297.465 103.841 298.181 104.398 298.408 105.482C298.659 106.671 298.161 107.636 296.801 108.144C295.815 108.51 295.603 109.017 295.819 110.007C296.791 114.479 296.367 115.88 297.535 116.993C298.441 117.852 298.359 120.391 297.549 121.535Z"
        fill="#86B1F2"
      />
      <path
        d="M498.22 355.015L504.619 356.258C519.761 359.197 534.229 364.903 547.296 373.09L548.73 373.988C548.73 373.988 559.723 368.24 555.145 357.905C539.416 353.451 524.853 347.263 510.81 339L506.111 335.808L498.22 355.015Z"
        fill="#466EB6"
      />
      <path
        d="M506.093 335.804C507.073 336.207 506.098 340.823 503.909 346.112C501.725 351.402 499.161 355.407 498.183 355.002C497.203 354.598 498.177 349.935 500.363 344.648C502.547 339.359 505.114 335.396 506.093 335.804Z"
        fill="#86B1F2"
      />
      <path
        d="M506.127 335.819L506.106 335.812C506.106 335.812 502.482 347.591 499.657 350.365L501.545 351.09C502.324 349.684 503.142 347.978 503.909 346.112C506.072 340.884 507.05 336.316 506.127 335.819Z"
        fill="#355389"
      />
      <path
        d="M529.179 348.497C529.934 349.642 532.688 354.914 525.724 362.312C526.746 362.705 527.765 363.112 528.776 363.532C533.031 358.612 533.667 354.404 533.413 351.668C533.372 351.239 533.295 350.672 533.213 350.249C531.861 349.68 530.517 349.099 529.179 348.497Z"
        fill="#B75742"
      />
      <path
        d="M525.525 360.36L513.033 367.75L517.503 368.352L517.785 372.597L527.454 362.244L525.525 360.36Z"
        fill="#B75742"
      />
      <path
        d="M528.457 362.488L528.963 372.824L531.271 369.709L533.984 371.356L530.929 362.1L528.457 362.488Z"
        fill="#B75742"
      />
      <path
        d="M531.427 363.474C529.381 364.999 526.446 364.526 524.873 362.418C523.3 360.311 523.685 357.364 525.733 355.837C527.779 354.312 530.714 354.785 532.287 356.893C533.86 359 533.475 361.947 531.427 363.474Z"
        fill="#F47458"
      />
      <path
        d="M447.438 175.388L407.017 168.925C404.39 168.505 403.118 164.991 404.586 162.208L417.661 137.434C418.499 135.849 420.023 134.969 421.52 135.21L461.94 141.674C464.568 142.094 465.838 145.605 464.37 148.388L451.295 173.162C450.459 174.75 448.935 175.63 447.438 175.388Z"
        fill="#9BC1F9"
      />
      <path
        d="M434.518 157.917L421.076 141.662C420.561 141.041 420.589 140.003 421.14 139.348C421.691 138.692 422.557 138.665 423.072 139.286L435.441 154.245L457.962 146.461C458.695 146.209 459.429 146.706 459.598 147.573C459.767 148.44 459.307 149.352 458.571 149.606L434.518 157.917Z"
        fill="white"
      />
      <path
        d="M46.9816 292.391L53.01 295.948L58.891 291.904L65.3654 296.364L70.3012 290.129L77.846 294.85L83.097 289.667L91.0993 293.027L89.8276 296.055L83.8453 293.545L78.3029 299.016L71.0505 294.474L66.0328 300.814L58.8879 295.893L53.1461 299.839L47.5563 296.546L44.3306 299.927L41.9531 297.658L46.9816 292.391Z"
        fill="#F7CC7F"
      />
      <path
        d="M454.771 220.776L461.649 219.495L463.426 212.583L471.24 211.694L470.864 203.749L479.656 202.354L480.212 194.996L488.45 192.271L489.48 195.388L483.323 197.428L482.737 205.192L474.285 206.534L474.667 214.613L466.045 215.593L464.308 222.341L457.934 223.529L457.72 228.201L454.439 228.05L454.771 220.776Z"
        fill="#50BFA5"
      />
    </>
  </SVGIcon>
);

export default NoInvitesIcon;
